const projectDetail = {
  notFound: "פרויקט לא נמצא",
  backToLayers: "חזרה להאב",
  layers: "שכבות",
  layer: "שכבה",
  source: "מקור",
  health: "בריאות",
  status: "סטטוס",
  documents: "מסמכים",
  newDoc: "צור מסמך",
  noDocuments: "אין מסמכים עדיין",
  storyMap: "vStory",
  openMap: "פתח מפה",
  noStoryCards: "אין כרטיסים עדיין",
  more: "נוספים",
} as const;
export default projectDetail;
